import React from 'react';
import PropTypes from 'prop-types';

class SimpleStepContent extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const { content, note } = this.props;

        return (
            <div className="step-content">
                <span style={{ whiteSpace: 'pre-line' }}>{content}</span>
                <br />
                <div className="font-italic margin-top-10">{note}</div>
            </div>
        );
    }
}

SimpleStepContent.propTypes = {
    content: PropTypes.string.isRequired,
    note: PropTypes.string,
};

SimpleStepContent.defaultProps = {
    note: undefined,
};

export default SimpleStepContent;
